import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { brand } from '../mock';

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a href={`https://wa.me/${brand.phoneRaw}?text=Hi%20Pikachu%20Classes,%20I%20would%20like%20a%20free%20demo%20class.`} target="_blank" rel="noreferrer" className="group w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center border-2 border-[#2C3E50] paper-shadow-sm hover:-translate-y-0.5" aria-label="WhatsApp">
        <MessageCircle size={22} />
      </a>
      <a href={`tel:${brand.phoneRaw}`} className="w-14 h-14 rounded-full bg-[#E64B2B] text-white flex items-center justify-center border-2 border-[#2C3E50] paper-shadow-sm hover:-translate-y-0.5 wiggle" aria-label="Call">
        <Phone size={20} />
      </a>
    </div>
  );
}
